import {SIDEBAR_OPEN, SIDEBAR_CLOSE} from 'app/redux/constants/actionTypes';

const sidebarToggle = (newState) => {
  // console.log('action:', state, payload)
  switch (newState) {
    case 'open' || true: 
      return {
        type: SIDEBAR_OPEN
      }
    case 'close' || false: 
      return {
        type: SIDEBAR_CLOSE
      }
    default:
      return {type: SIDEBAR_CLOSE};
  }
};

export default sidebarToggle;